import type { MyEstimateGroup } from '@massilia/contracts'

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { estimateAuthHeaders } from './estimate-token.js'
import { publicEstimateRequestKeys } from './keys.js'

/**
 * Une demande vue hors session, derrière le jeton de portée `estimate` — jamais
 * le jeton de session, qui n'ouvre pas cette route.
 */
export const useGetPublicRequestQuery = (estimateId: string, enabled: boolean) =>
  useQuery({
    enabled,
    queryFn: async () => {
      const response = await apiClient.client.get<MyEstimateGroup>(
        `/public/estimates/${estimateId}`,
        { headers: estimateAuthHeaders(estimateId) }
      )

      return response.data
    },
    queryKey: publicEstimateRequestKeys.request(estimateId),
  })
